<template>
  <div class="flex-align-center di-ding-op-bar-item margin-left-12" >
    <!-- region 按钮 -->
    <button-add v-if="item.type === 'button-add'"
                @click="handleAdd(item.onClick)"
                :value="item.label" />
    <button-cancel v-else-if="item.type === 'button-cancel'"
                   @cancel="handleAdd(item.onClick)"
                   :value="item.label" />
    <!-- endregion 添加按钮 -->
    <!-- region 导入按钮 -->
    <!--<el-button v-else-if="item.type === 'button-download'"-->
               <!--class="button-download"-->
               <!--@click="handleDownload">-->
      <!--<i class="el-icon-damai-daochu"></i>{{item.label}}-->
    <!--</el-button>-->
    <button-upload v-else-if="item.type === 'button-uploadTable'" :cathUrl="item.uploadUrl" :onSuccess="onUploadSuccess" />
    <!-- endregion 导入按钮 -->
    <!-- region 导出按钮 -->
    <!--<el-button v-else-if="item.type === 'button-download'"-->
               <!--class="button-download"-->
               <!--@click="handleDownload">-->
      <!--<i class="el-icon-damai-daochu"></i>{{item.label}}-->
    <!--</el-button>-->
    <!-- endregion 导出按钮 -->

    <!-- region 导出按钮2 -->
    <button-export v-else-if="item.type === 'button-download'"
                   class="margin-left-16"
                   :icon-class="item.icon || 'el-icon-download'"
                   :value="item.label"
                   :beforeDownload="item.beforeDownload"
                   :href="item.getDownloadUrl(requestBody)"
                   :getDownloadUrl="() => item.getDownloadUrl(requestBody)"
    />
    <!-- endregion 导出按钮2 -->

    <!-- region 搜索栏 -->
    <!--suppress JSUnusedLocalSymbols -->
    <input-search v-else-if="item.type === 'input-search'" class="input-search" :style="{width: item.width}"
                  @search="data => search({[item.searchKey]: data})"
                  :placeholder="item.label" />
    <!-- endregion 搜索栏 -->

    <!-- region 下拉选择框 -->
    <div v-else-if="item.type === 'search-selector'"
         class="flex-space-between-align-center" :style="{width: item.width, marginRight: item.marginRight, marginLeft: item.marginLeft}"
    >
      <span style="display:inline-block;min-width: 60px;margin-right: 5px">{{item.label}}</span>
      <!--suppress RequiredAttributes -->
      <el-select v-model="current"
                 placeholder="请选择" size="small" class="flex-auto"
                 @change="val => search({[item.searchKey]: val})"
      >
        <el-option v-for="it in detailsFromData || detailsFromServer"
                   :key="it._value" :label="it._label" :value="it._value" />
      </el-select>
    </div>
    <!-- endregion 下拉选择框 -->

    <div v-else-if="item.type === 'search-enrollmentYear'" id="enrollmentYear">
      <span class="margin-right-16" style="min-width: 30px;">{{item.label}}</span>
      <el-date-picker v-model="enrollmentYear" align="right" type="year" format="yyyy级" value-format="yyyy" :editable="readDate" placeholder="请选择年级" @change="val => search({[item.searchKey]: val})" style="line-height: 30px;width: 100px"></el-date-picker>
    </div>

    <!-- region 树 -->
    <div v-else-if="item.type === 'search-tree'" class="flex-align-center" :style="{width: item.width}">
      <span class="margin-right-16" style="min-width: 60px;">{{item.label}}</span>
      <input-tree class="input-tree" label="请选择"
                  :fetch="item.fetchDetail"
                  @input="val => search({[item.searchKey]: val._value})" />
    </div>
    <!-- endregion 树 -->

    <!-- region 树 -->
    <div v-else-if="item.type === 'search-device-tree'" class="flex-align-center" :style="{width: item.width}">
      <span class="margin-right-16" style="min-width: 40px;">{{item.label}}</span>
      <input-device-tree class="input-tree" label="请选择"
                  :fetch="item.fetchDetail"
                  @input="val => search({[item.searchKey]: val._value})" />
    </div>
    <!-- endregion 树 -->

    <!-- region 日期选择 -->
    <input-date-range v-else-if="item.type === 'date-range-picker'"
                      v-model="dateRangeCurrent"
                      :picker-options="item.pickerOptions"
                      @change="val => search(item.entityInSearchRequestBody(val))"
    />
    <!-- endregion 日期选择 -->

    <input-date-month v-else-if="item.type === 'date-month'"
                      :picker-options="item.pickerOptions"
                      @change="val => search(item.entityInSearchRequestBody(val))"
    />

    <!-- region 日期选择时分秒 -->
    <input-date-second v-else-if="item.type === 'date-second'"
                       v-model="dateRangeCurrent"
                       :picker-options="item.pickerOptions"
                       @change="val => search(item.entityInSearchRequestBody(val || []))"
    />
    <!-- endregion 日期选择时分秒 -->

    <!-- region tabs -->
    <el-tabs v-else-if="item.type === 'tabs'"
             class="el-tab margin-right-16 margin-top-8" :value="0"
             @tab-click="onTabClick" :style="{flex: item.flex}">
      <el-tab-pane class="tab-pane" v-for="{label} in item.configs"
                   :label="label" :key="label" />
    </el-tabs>
    <!-- endregion tabs -->

    <ConsumeContent v-else-if="item.type === 'render'" :vm="that"
                    :data="this.data || {}" :renderContent="item.renderContent"
                    @change="search()"
    />

  </div>
</template>

<script>
import diDingMixin from '../pages/di-ding-mixin'
import ButtonAdd from '../../buttons/button-add'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import ButtonDelete from '../../buttons/button-delete'
import ButtonExport from '../../buttons/button-export'
import ButtonUpload from '../../buttons/button-upload'
import InputSearch from '../../inputs/input-search'
import InputTree from '../../inputs/input-tree'
import {ConsumeContent} from './consume-content'
import {downloadFile} from '../../../../utils/browser'
import InputDateRange from '../../inputs/input-date-range'
import {errorHandler} from '../../../../utils/errorHandler'
import InputDateSecond from '../../inputs/input-date-second'
import InputDateMonth from '../../inputs/input-date-month'
import {nSuccess} from '../../../../utils/notice'
import InputDeviceTree from '../../inputs/input-device-tree'

export default {
  components: {
    InputDeviceTree,
    InputDateMonth,
    InputDateSecond,
    InputDateRange,
    InputTree,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    ButtonCancel,
    ConsumeContent
  },
  name: 'op-bar-item',
  mixins: [diDingMixin],
  props: {
    data: {},
    requestBody: {},
    item: {
      // 不许为空
    }
  },
  data () {
    return {
      current: null, // 当前的选择项（selector等）
      dateRangeCurrent: this.item.default && this.item.default(),
      detailsFromServer: [], // 选项
      that: this.$parent.$parent,
      loading: false,
      readDate: false,
      enrollmentYear: ''
    }
  },
  created () {
    this.render()
  },
  computed: {
    detailsFromData () {
      return this.item['keyMappingKey'] &&
        this.data &&
        this.data[`_${this.item['keyMappingKey']}`].list
    }
  },
  methods: {
    render () {
      if (this.item.fetchDetail) {
        this.item.fetchDetail()
          .then(details => {
            if (!this.item.noAll) {
              this.current = '全部'
              details.unshift({_label: '全部', _value: ''})
            }
            this.detailsFromServer = details
            return details
          })
          .then(details => {
            if (this.item.default) {
              if (details.length > 0) {
                this.current = this.item.default(details)._value
                this.search({[this.item.searchKey]: this.current})
              }
            }
          })
          .catch(errorHandler('获取数据信息失败'))
      }
    },
    defaultCreateFunc () {
      this.routerPush('diDingCreate', {diName: this.diName})
    },
    handleAdd (func) {
      (this.bind(func, this) || this.defaultCreateFunc)()
    },
    onUploadSuccess (data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.$emit('search', '')
      }
    },
    handleDownload () {
      this.loading = true
      const {download, getDownloadUrl, href} = this.item
      if (!getDownloadUrl && !href) {
        console.debug('该下载有问题')
        return
      }
      const url = href || getDownloadUrl(this.that['requestBody'])
      setImmediate(() => {
        downloadFile(download, url)
      })
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    search (entity) {
      this.$emit('search', entity)
    },
    onTabClick ({label: currentLabel}) {
      const {key} = this.item.configs.find(({label}) => currentLabel === label)

      this.search({[this.item.searchKey]: key})
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../../common/styles/fun_var";

  .input-search {
    width: 240px;
  }
  .button-download {
    .generate-common-button(#F7F7F7);
    padding-top: 5px;
    padding-bottom: 5px;
    margin-right: 0;
    margin-left: 16px;
    line-height: unset;
    i {
      vertical-align: bottom;
    }
    &:hover {
      cursor: pointer;
      color: #1362FF;
      background-color: #F7F7F7;
      border: 1px solid #1362FF;
    }
  }

  .input-tree {
    height: 32px;
    width: 215px;
    color: #c0c4cf;
    font-size: 14px;
    border-radius: 4px;
  }

  .el-range-editor.el-input__inner {
    padding-top: 0;
  }
</style>

<style lang="less">
  /*noinspection CssUnusedSymbol*/
  .di-ding-op-bar-item .el-tabs__nav {
    float: none;
  }

  .di-ding-op-bar-item {
    .el-tabs__item:nth-child(2) {
      margin-right: 20px;
    }
    .el-tabs__item {
      padding: 0 20px !important;
      width: 120px;
      text-align: center;
    }
    .el-tabs__item:hover {
      border-bottom: 2px solid #409EFF;
    }
    .el-tabs__active-bar {
      height: 2px !important;
      width: 120px !important;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
  .el-select-dropdown {
    min-height: 200px;
  }
  .line {
    .el-input__prefix {
      display: none;
    }
  }
  #enrollmentYear {
    margin: 0 10px;
    width: 180px;
  }
  #enrollmentYear {
    .el-input__inner {
      width: 120px;
      height: 30px;
      padding: 10px 10px 10px 30px;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/common/op-bar-item.vue